const MuiLink = {
  root: {
    fontFamily: 'Prelo',
    fontSize: '16px',
    fontWeight: '500',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#2f7abf !important',
    cursor: 'pointer',
  },
  underlineHover:{
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',  
      color: '#2f7abf !important',
      cursor: 'pointer'
    }
  }
}

export default MuiLink
